import { render, staticRenderFns } from "./dictionary-detail.vue?vue&type=template&id=8f8cedb8&scoped=true&"
import script from "./dictionary-detail.vue?vue&type=script&lang=js&"
export * from "./dictionary-detail.vue?vue&type=script&lang=js&"
import style0 from "./dictionary-detail.vue?vue&type=style&index=0&id=8f8cedb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8cedb8",
  null
  
)

export default component.exports